module.exports = __webpack_public_path__ + "img/timeoff.652d2fe4.png";